// Importar componentes y estilos necesarios
import Card from 'react-bootstrap/Card'; // Importa el componente de Card de react-bootstrap
import { Typography } from '@mui/material';

import './style.css'

// Componente Funcional FormularioResponsable que recibe props
const FormularioResponsable = ({ ListError, StyleDragArea, Style, CustomToggle, FormResponsable, OnChange, Accordion }) => {
    const handleChangethelepones = (e) => {
        if (e.target.value.length < 11) {
 if(/^\d{0,10}$/.test(e.target.value))
        {
            OnChange(e);
        }        }
    }


      const handleChangeNombre = (e) => {
          if (/^[a-zA-ZáéíóúÁÉÍÓÚñÑüÜäÄëËïÏöÖ\s]*$/.test(e.target.value)) {
        OnChange(e);
    }
    }


        const handleChangeEmail = (e) => {
         if(/^[a-zA-Z0-9@._-]*$/.test(e.target.value))
        {
            OnChange(e);
        }
    }

    
    return (
        <div style={{ backgroundColor: 'white' }}>


            <Accordion.Collapse style={{}} eventKey="0" id="panelsStayOpen-collapseOne" aria-labelledby="panelsStayOpen-headingOne" >

                <Card.Body style={{ backgroundColor: 'white', padding: '2px' }}>
                    {/* Formulario para ingresar datos del responsable */}
                    <Typography mb='0px' mt='10px' color='black' textAlign='left'  style={{ lineHeight: 'normal' }} >
                    A través de este contacto se notificará tu compra o cambios en tu pedido.                        {/* <a id="btnEditar" className="btn btn-primary btnAmarillo seleccion editar" onclick="editar()" >Editar</a> */}
                    </Typography>
                    <div style={{ padding: '0px 5px', textAlign: 'left', fontSize: '16px' }} className="row inputDatos">
                        {/* Input para Nombre */}
                        <div className="col-sm-4">
                             <Typography  htmlFor="inNombre_responsable" className='fz-18'>Nombre(s)*</Typography>
                            <input style={{ border: ListError.find((element) => element.item === 'Nombre').error === true ? '3px solid rgb(239, 83, 80)' : '' }} value={FormResponsable.Nombre} type="text" name='Nombre' onChange={handleChangeNombre} className="form-control " id="inNombre_responsable" placeholder="Nombre(s)" />
                            {/* {
                            ListError.find((element)=> element.item==='Nombre').error===true
                            ?<>error</>
                            :<></>
                        } */}
                        </div>
                        {/* Input para Apellido Paterno */}
                        <div className="col-sm-4">
                             <Typography  htmlFor="inApellidoPaterno_responsable" className='fz-18'>Apellido paterno*</Typography >
                            <input style={{ border: ListError.find((element) => element.item === 'ApellidoPaterno').error === true ? '3px solid rgb(239, 83, 80)' : '' }} type="text" value={FormResponsable.ApellidoPaterno} name='ApellidoPaterno' onChange={handleChangeNombre} className="form-control " id="inApellidoPaterno_responsable" placeholder="Apellido paterno" />
                        </div>
                        {/* Input para Apellido Materno */}
                        <div className="col-sm-4">
                             <Typography htmlFor="inApellidoMaterno_responsable" className='fz-18'>Apellido materno*</Typography >
                            <input style={{ border: ListError.find((element) => element.item === 'ApellidoMaterno').error === true ? '3px solid rgb(239, 83, 80)' : '' }} type="text" value={FormResponsable.ApellidoMaterno} name='ApellidoMaterno' onChange={handleChangeNombre} className="form-control " id="inApellidoMaterno_responsable" placeholder="Apellido materno" />
                        </div>
                        {/* Input para Teléfono 1 */}
                        <div className="col-sm-6">
                             <Typography  htmlFor="TelefonoUno_responsable" className='fz-18'>Teléfono*</Typography >
                            <StyleDragArea><input onKeyDown={(e) => {
                                            if (e.key === 'e' || e.key === 'E' || e.key === '-' || e.key === '+') {
                                                e.preventDefault(); // Bloquea la tecla "e"
                                            }
                                        }} style={{ border: ListError.find((element) => element.item === 'TelefonoPrimario').error === true ? '3px solid rgb(239, 83, 80)' : '' }} maxLength={5} value={FormResponsable.TelefonoPrimario} type="number" name='TelefonoPrimario' onChange={handleChangethelepones} className="form-control " id="TelefonoUno_responsable" placeholder="Teléfono" /></StyleDragArea>
                        </div>
                        {/* Input para Teléfono 2 */}
                        <div className="col-sm-6">
                             <Typography  htmlFor="TelefonoDos_responsable" className='fz-18'>Teléfono 2*</Typography >    
                            <StyleDragArea><input  onKeyDown={(e) => {
                                            if (e.key === 'e' || e.key === 'E' || e.key === '-' || e.key === '+') {
                                                e.preventDefault(); // Bloquea la tecla "e"
                                            }
                                        }} style={{ border: ListError.find((element) => element.item === 'TelefonoSecundario').error === true ? '3px solid rgb(239, 83, 80)' : '' }} maxLength="12" value={FormResponsable.TelefonoSecundario} type="number" name='TelefonoSecundario' onChange={handleChangethelepones} className="form-control " id="TelefonoDos_responsable" placeholder="Teléfono 2" /></StyleDragArea>
                        </div>
                        {/* Input para Correo Electrónico */}
                        <div className="col-sm-6">
                             <Typography  htmlFor="CorreoElectronico_responsable" className='fz-18'>Correo electrónico*</Typography >
                            <input style={{ border: ListError.find((element) => element.item === 'Email').error === true ? '3px solid rgb(239, 83, 80)' : '' }} type="text" name='Email' value={FormResponsable.Email} onChange={handleChangeEmail} className="form-control " id="CorreoElectronico_responsable" placeholder="Correo@ejemplo.com.mx" />
                        </div>
                        {/* Input para Confirmación de Correo Electrónico */}
                        <div className="col-sm-6">
                             <Typography  htmlFor="ConfirmaCorreoElectronico_responsable" className='fz-18'>Confirma tu correo electrónico*</Typography >
                            <input style={{ border: ListError.find((element) => element.item === 'EmailConfirmar').error === true ? '3px solid rgb(239, 83, 80)' : '' }} type="text" value={FormResponsable.EmailConfirmar} name='EmailConfirmar' onChange={handleChangeEmail} className="form-control " id="ConfirmaCorreoElectronico_responsable" placeholder="Confirma tu correo electrónico" />
                        </div>
                        {/* Botón para guardar */}
                        <div className="col-sm-3 AlbertBold" style={{color:'#D14081', margin:'40px 0px 40px 0px'}} >
                            *Obligatorio
                        </div>
                        <div className="col-sm-9 buttonGuardar" >
                            <div>
                                <Style>
                                    <CustomToggle eventKey="1">Guardar</CustomToggle>
                                </Style>
                            </div>
                        </div>
                    </div>
                </Card.Body>
            </Accordion.Collapse>
        </div>

    );
}

export default FormularioResponsable; // Exporta el componente FormularioResponsable
